import { updateAcknowledgement } from "../../services/api/onboarding/acknowledgements";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";
import { acknowledgementVersions } from "../constants/acknowledgements";

export async function updateAcknowledgements(
  acknowledgements: onboardingApiSpec.AcknowledgementName[]
) {
  const acknowledgementPromises = acknowledgements.map(acknowledgementName =>
    updateAcknowledgement(acknowledgementName, {
      acknowledgementName: acknowledgementName,
      acknowledgementStatus: "Given",
      version: acknowledgementVersions[acknowledgementName]
    })
  );

  return await Promise.all(acknowledgementPromises);
}
